import VadImage from "vadimages-nextjs-image-optimizer";

export const SingularCompatibleBadge = () => (
  <>
    <VadImage
      src="/images/singular/singular-badge-aurora.png"
      alt="Singular Compatible Badge"
      width={330}
      height={144}
    />
  </>
);
